import { DiamondsContent } from '../../../../lib/kontent/navigation-helpers/get-diamonds-content'
import { HeaderImageColumn } from '../image-column'
import { HeaderLinkColumn } from '../link-column'
import { Link } from '@gassan-ui'
import NextLink from 'next/link'
import { FC } from 'react'

type HeaderShopMenuDiamondsProps = DiamondsContent

export const HeaderShopMenuDiamonds: FC<HeaderShopMenuDiamondsProps> = ({
  linkList,
  imageLinkFirstColumn,
  imageLinkSecondColumn,
}) => {
  return (
    <>
      <HeaderLinkColumn
        title={linkList.title}
        readMoreLink={
          linkList.viewMore && (
            <NextLink href={linkList.viewMore.url} passHref legacyBehavior>
              <Link variant="blue">{linkList.viewMore.label}</Link>
            </NextLink>
          )
        }
        links={linkList.links}
        linkSpace="regular"
      />
      <HeaderImageColumn {...imageLinkFirstColumn} />
      <HeaderImageColumn {...imageLinkSecondColumn} showOnlyOnXlarge />
    </>
  )
}
